<template>
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
  >
    <path d="M15.2466 11.5C15.2466 10.6716 14.5751 10 13.7466 10H6.74664C5.91822 10 5.24664 10.6716 5.24664 11.5V12C5.24664 13.9714 7.10615 16 10.2466 16C13.3871 16 15.2466 13.9714 15.2466 12V11.5ZM12.9966 6.25C12.9966 4.73122 11.7654 3.5 10.2466 3.5C8.72786 3.5 7.49664 4.73122 7.49664 6.25C7.49664 7.76878 8.72786 9 10.2466 9C11.7654 9 12.9966 7.76878 12.9966 6.25ZM20.2466 10C20.2466 15.5228 15.7695 20 10.2466 20C4.7238 20 0.246643 15.5228 0.246643 10C0.246643 4.47715 4.7238 0 10.2466 0C15.7695 0 20.2466 4.47715 20.2466 10ZM18.7466 10C18.7466 5.30558 14.9411 1.5 10.2466 1.5C5.55222 1.5 1.74664 5.30558 1.74664 10C1.74664 14.6944 5.55222 18.5 10.2466 18.5C14.9411 18.5 18.7466 14.6944 18.7466 10Z" />
  </svg>
</template>
